import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg<{ orientation: 'left' | 'right' }>`
  transform: ${({ orientation }) => (orientation === 'right' ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

const ChevronWhite = ({ height, orientation }: { height: number; orientation: 'left' | 'right' }): JSX.Element => {
  return (
    <Svg
      orientation={orientation}
      height={height}
      viewBox='0 0 6 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.868 1.55699L2.152 6.99999L5.868 12.443C6.142 12.845 5.976 13.356 5.496 13.585C5.016 13.815 4.406 13.675 4.132 13.274L0.132 7.41499C0.0463468 7.29356 0.000366211 7.1486 0.000366211 6.99999C0.000366211 6.85139 0.0463468 6.70643 0.132 6.58499L4.132 0.725994C4.406 0.324994 5.017 0.185994 5.496 0.414994C5.976 0.643994 6.142 1.15499 5.868 1.55699V1.55699Z'
        fill='white'
      />
    </Svg>
  );
};

export default ChevronWhite;
